import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "@/components/layout/maintenance";
import { RfmWidget } from "@/components/specific/rfm";

const monthYearFormatter = new Intl.DateTimeFormat(undefined, { month: "short", year: "numeric" });

const formatMonthYear = (date: Date) => {
  const parts = monthYearFormatter.formatToParts(date);
  const month = parts.find(part => part.type === "month")?.value ?? "";
  const year = parts.find(part => part.type === "year")?.value ?? "";
  return `${month} ${year}`;
};

const getDateRangeLabel = () => {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth() - 11, 1);
  return `${formatMonthYear(start)} to ${formatMonthYear(end)}`;
};

export const RfmPage = () => (
    <div>
        <MaintenanceSection>
            <MaintenanceSectionHeader title={`RFM analysis - Active customers - ${getDateRangeLabel()}`} subtitle="Review customer segments using recency, frequency, and monetary value." noMargin />

        <MaintenanceSectionContent><RfmWidget /></MaintenanceSectionContent>
      </MaintenanceSection>
  </div>
);